// 合并所有reducer 并且返回
import { combineReducers } from 'redux'
import { map } from './map'
import { dataSource } from './dataSource'
import { trajectory } from './trajectory'
import { baseMap } from './baseMap'
import { datePicker } from './datePicker'
export default combineReducers({ map, dataSource, trajectory, baseMap, datePicker })
